// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHorizontalSmallHeadingAndTextStyles } from "@sc/App/SharedStyles/smallHeadingAndTextStyles";
import {
    autocompleteProductsStyles,
    AutocompleteProductsStyles,
} from "@sc/Overrides/Widgets/Header/AutocompleteProducts";
import { color, xScreen } from "@sc/XDL/Utilities";
import { ellipsis } from "@sc/XDL/Utilities/string";
import { css } from "styled-components";

const autocompleteProductsStylesExtensions: AutocompleteProductsStyles = {
    container: {
        css: css`
            display: flex;
            gap: 12px;
            width: calc(50% - 11px);
            max-width: calc(50% - 11px);
            ${xScreen("lte", "sm")} {
                width: 100%;
                max-width: 100%;
            }
        `,
    },
    imageGridItem: {
        width: 3,
        css: css`
            max-width: 91px;
            max-height: 91px;
            flex-basis: 91px;
        `,
    },
    image: {
        css: css`
            width: 91px;
            min-width: 91px;
            height: 91px;
            & > img {
                max-width: 100%;
                max-height: 100%;
                height: auto;
                width: auto;
                border-radius: 4px;
            }
        `,
    },
    infoGridItem: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 12px;
            max-width: 200px;
        `,
    },
    skuAndDescriptionContainer: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    titleLink: {
        color: "common.black",
        typographyProps: {
            css: css`
                display: block;
                line-height: 13px;
            `,
        },
        css: css`
            margin-bottom: 8px;
            ${ellipsis(3)}
            &:hover,
            &:focus {
                color: ${color("common.ui8")};
            }
        `,
    },
    erpNumberTextSmallHeading: {
        ...createHorizontalSmallHeadingAndTextStyles(),
    },
};

autocompleteProductsStyles.container = autocompleteProductsStylesExtensions.container;
autocompleteProductsStyles.imageGridItem = autocompleteProductsStylesExtensions.imageGridItem;
autocompleteProductsStyles.image = autocompleteProductsStylesExtensions.image;
autocompleteProductsStyles.infoGridItem = autocompleteProductsStylesExtensions.infoGridItem;
autocompleteProductsStyles.titleLink = autocompleteProductsStylesExtensions.titleLink;
autocompleteProductsStyles.erpNumberTextSmallHeading = autocompleteProductsStylesExtensions.erpNumberTextSmallHeading;
autocompleteProductsStyles.skuAndDescriptionContainer = autocompleteProductsStylesExtensions.skuAndDescriptionContainer;
